import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";

const style = {
  grid: {
    marginRight: "-15px",
    marginLeft: "-15px",
    width: "auto",
  }
  // {direction:"column", justify:"flex-end", alignItems:"center"}
};

function GridContainer({ ...props }) {
  const { classes, direction, justify, alignItems, children, className, ...rest } = props;
  // if (pollTemplate) {
  //   classes.grid.direction = "column";
  //   classes.grid.justify = "flex-end";
  //   classes.grid.alignItems = "center";
  // }

  return (
    <Grid
      container
      direction={direction}
      justify={justify}
      alignItems={alignItems}
      {...rest}
      className={classes.grid + " " + className}
    >
      {children}
    </Grid>
  );
}

GridContainer.defaultProps = {
  className: ""
};

GridContainer.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
  className: PropTypes.string
};

export default withStyles(style)(GridContainer);



// WEBPACK FOOTER //
// ./src/components/Grid/GridContainer.jsx